import { useAuth } from '@ocula/auth';
import { I18nProvider } from '@ocula/i18n-formatters';
import { PageLoading } from '@ocula/ui';
import { Suspense, memo } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';

import { appPages } from '@src/appPages';
import { PageError, PageErrorBoundary } from '@src/components/ErrorState';
import { AuthenticatedLayout } from '@src/layouts/AuthenticatedLayout';
import LoginPage from '@src/pages/Login';

import { SilentLoginInterstitial } from './pages/Login/SilentLoginInterstitial';
import { AuthenticatedInterstitial } from './pages/auth/AuthenticatedInterstitial';
import { AuthorisedRoute } from './pages/auth/AuthorisedRoute';
import { RedirectToOrganizationHomePage } from './pages/auth/RedirectToOrganisationHomePage';

export const AppRouting = memo(() => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  return (
    <Routes>
      <Route element={<SilentLoginInterstitial />}>
        <Route path="login" element={isAuthenticated ? <Navigate to="/" replace /> : <LoginPage />} />
        <Route path="not-found" element={<PageError error={404} />} />
        <Route element={<AuthenticatedInterstitial />}>
          <Route
            path=":orgName"
            element={
              <I18nProvider>
                <AuthenticatedLayout appPages={appPages} />
              </I18nProvider>
            }
          >
            {appPages.map(({ path, element: Element }) => (
              <Route
                key={path}
                path={path.substring(1)}
                element={
                  <PageErrorBoundary location={location}>
                    <Suspense fallback={<PageLoading />}>
                      <AuthorisedRoute path={path}>
                        <Element />
                      </AuthorisedRoute>
                    </Suspense>
                  </PageErrorBoundary>
                }
              />
            ))}
            <Route path="*" element={<PageError error={404} />} />
          </Route>
          <Route path="/" element={<RedirectToOrganizationHomePage />} />
        </Route>
      </Route>
    </Routes>
  );
});
